import { createFileRoute } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/citizens/$citizenId/")({
  component: RouteComponent
})

function RouteComponent() {
  return <div>Hello "/_authenticated/tablet/$orgId/_tablet/citizens/$citizenId/"!</div>
}
